/*
 * @Author: Claude (Refactored v3)
 * @Date: 2025-12-31
 * @Description: 音频上传组件（支持音频和视频文件，统一以音频播放器形式预览）
 */
import { FC } from 'react';

import { useTranslate } from '@/hooks/useTranslate';

import { UploadPlaceholder } from '../common/components/UploadPlaceholder';
import { defaultConfig } from '../config';
import { Upload } from '../core/Upload';
import { FilePreviewItem } from './components/FilePreviewItem';
import { AudioUploadProps } from './types';

/**
 * 音频上传组件
 * 支持音频和视频文件的上传、预览和删除
 * 支持多文件并发上传，每个文件独立管理上传进度
 * 根据文件类型自动选择对应的播放器（音频播放器或视频的音频部分）
 * 本质上是 Upload 组件的预配置版本（previewType="media-list"）
 */
const AudioUpload: FC<AudioUploadProps> = (props) => {
  const { children, feature, ...restProps } = props;

  const { t } = useTranslate();

  return (
    <Upload
      {...restProps}
      previewType="media-list"
      config={defaultConfig}
      feature={feature}
      enableTracking={!!feature}
      uploadPlaceholder={
        <UploadPlaceholder
          tips={
            <div className="flex flex-col text-[10px] text-[#111111]/35">
              <div>{t('MP3-WAV-M4a-100MB-10-3')}</div>
              <div>{t('500MB-10-3-MP4-MOV-2')}</div>
            </div>
          }
        />
      }
      footerTip={t('87ba05d4423bdb4c3f4e429761bd6c9b')}
      renderPreview={{
        list: (originNode, file, fileList, onDelete) => (
          <FilePreviewItem key={file.uid} file={file} onDelete={onDelete} />
        ),
      }}
    >
      {children}
    </Upload>
  );
};

export default AudioUpload;
